/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placeheaderstatus2Inputs */

const en_placeheaderstatus2 = /** @type {(inputs: Placeheaderstatus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

const de_placeheaderstatus2 = /** @type {(inputs: Placeheaderstatus2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status`)
};

/**
* | output |
* | --- |
* | "Status" |
*
* @param {Placeheaderstatus2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placeheaderstatus2 = /** @type {((inputs?: Placeheaderstatus2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placeheaderstatus2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placeheaderstatus2(inputs)
	return de_placeheaderstatus2(inputs)
});
export { placeheaderstatus2 as "placeHeaderStatus" }